<script setup lang="ts">
import { provide } from 'vue';
import DashboardPanel from '@/modules/dashboard/components/DashboardPanel.vue';
import BrokerMarketplaceOrdersList from '@/modules/broker-admin/components/BrokerMarketplaceOrdersList.vue';

provide('gridStateKey', 'BrokerMarketplaceOrdersView');
</script>

<template>
  <div>
    <DashboardPanel no-collapse title="orders">
      <BrokerMarketplaceOrdersList />
    </DashboardPanel>
  </div>
</template>

<style lang="scss"></style>
